<div class="pos_relative">
    <button disabled class="in_progress color_dark_green fz_title">В процессе</button>
    <app-table [path]="'customers'" [dataMissing]="dataMissing" [data]="customers" [columns]="columns" [pagination]="{
                    currentPage: currentPage,
                    pageSize: pageSize,
                    totalItems: totalItems
                }" (pageChange)="onPageChange($event)"><app-skeleton *ngIf="isLoading" height="40" margin="15"
            count="12"></app-skeleton></app-table>
</div>